import * as React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import styled from 'styled-components';

import {
  breakpoints,
  IconRegularClose,
  IconSolidInfo,
  Text,
  theme,
} from '@notino/react-styleguide';

import { LOGIN_URL, WISHLIST_BASE_URL } from '@constants';
import { useUser } from '@queries/useUser';

const Wrapper = styled.div`
  margin-top: 1rem;
  padding: 0.75rem;
  background: ${theme.color.background.secondary};
  display: flex;
  gap: 0.5rem;
`;

const CloseButton = styled.button`
  all: unset;
  width: 44px;
  height: 44px;
  display: none;
  align-items: center;
  justify-content: end;
  margin-left: auto;
  cursor: pointer;
  align-self: center;

  @media (min-width: ${breakpoints.md}) {
    display: flex;
  }
`;

const messages = defineMessages({
  title: {
    id: 'wishlist.lists.logInBanner.title',
    defaultMessage: 'Nejste přihášeni',
  },
  text: {
    id: 'wishlist.lists.logInBanner.text',
    defaultMessage:
      'Vaše seznamy jsou k dispozici pouze na tomto zařízení a vyprší 30 dní po vaší poslední návštěvě notino.cz. Pro trvalý přístup k oblíbeným položkám se jednoduše <link>přihlaste do svého účtu</link>.',
  },
});

export const LogInBanner = () => {
  const [visible, setVisible] = React.useState(!useUser().isLoggedIn);

  if (!visible) {
    return null;
  }

  return (
    <Wrapper>
      <IconSolidInfo
        color="icon.tertiary"
        width="19px"
        height="19px"
        style={{ minWidth: '19px' }}
      />

      <div>
        <Text typography="labelRegular" marginBottom="4px" block={true}>
          <FormattedMessage {...messages.title} />
        </Text>
        <Text typography="labelRegular400" color="text.secondary">
          <FormattedMessage
            {...messages.text}
            values={{
              link: (chunks) => (
                <a href={LOGIN_URL(WISHLIST_BASE_URL)}>{chunks}</a>
              ),
            }}
          />
        </Text>
      </div>

      <CloseButton onClick={() => setVisible(false)}>
        <IconRegularClose width="20px" height="20px" color="icon.secondary" />
      </CloseButton>
    </Wrapper>
  );
};
